export enum ChangeRequestFileOperation {
  ADDED = 'added',
  REMOVED = 'removed',
}
